/* eslint-disable jsx-a11y/no-autofocus */
import React from 'react';
import Icon from 'assets/Icon';
import styles from './style/searchField.module.css';

interface SearchFieldProps {
  autoFocus?: boolean,
  icon?: boolean,
  keydownHandler: Function,
  maxLength?: number,
  onChangeHandler: Function,
  onPasteHandler: Function,
  pattern?: string,
  placeholderText?: string,
  validationMessage?: string | React.ReactNode,
  value?: string | number,
}

const SearchField = ({
  autoFocus,
  icon,
  keydownHandler,
  maxLength,
  onChangeHandler,
  onPasteHandler,
  pattern,
  placeholderText,
  validationMessage,
  value,
}:SearchFieldProps) => (
  <div className={styles.searchField}>
    { icon ? (
      <div className={styles.searchField__icon}>
        <Icon icon="Search" fill="warm-grey-200" />
      </div>
    ) : null}
    <input
      autoFocus={autoFocus}
      onChange={(e) => onChangeHandler(e)}
      onKeyDown={(e) => keydownHandler(e)}
      onPaste={(e) => onPasteHandler(e)}
      maxLength={maxLength}
      pattern={pattern}
      placeholder={placeholderText}
      value={value}
    />
    <div className={styles.searchField__validation}>
      { validationMessage }
    </div>
  </div>
);

SearchField.defaultProps = {
  autoFocus: false,
  icon: true,
  maxLength: 1000,
  pattern: '',
  placeholderText: 'Search',
  validationMessage: '',
  value: '',
};

export default SearchField;
